import { Controller } from "react-hook-form/dist/index.ie11";
import ErrorMessage from "./ErrorMessage";
import Label from "./Label";
import { useFormContext } from "./FormProvider";
import { v4 as uuidv4 } from "uuid";

const UUID = uuidv4();

StandardInput.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  label: PropTypes.string,
  rules: PropTypes.object,
  defaultValue: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  middleware: PropTypes.func,
  labelVisible: PropTypes.bool,
};

StandardInput.defaultProps = {
  name: "input",
  label: "Label",
  placeholder: "Text...",
  type: "text",
  defaultValue: "",
  className: "",
  middleware: (value) => value,
};

export default function StandardInput({
  name,
  placeholder,
  type,
  label,
  rules,
  className,
  defaultValue,
  disabled,
  middleware,
  labelVisible,
}) {
  const { control, errors } = useFormContext();
  const id = `${name}__${UUID}`;

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      defaultValue={defaultValue}
      render={({ onChange, value = "" }) => (
        <div
          className={"field field-input " + className}
          style={{ display: type === "hidden" ? "none" : "block" }}
        >
          {labelVisible && <Label value={label} htmlFor={id} />}
          <div className={"control"}>
            <input
              id={id}
              disabled={disabled}
              onChange={(e) => onChange(middleware(e.target.value))}
              type={type}
              name={name}
              value={value}
              placeholder={placeholder}
              className={"input"}
            />
          </div>
          <ErrorMessage error={errors[name]} />
        </div>
      )}
    />
  );
}
